import { render, staticRenderFns } from "./ImportContacts.vue?vue&type=template&id=66c61334&"
import script from "./ImportContacts.vue?vue&type=script&lang=js&"
export * from "./ImportContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66c61334')) {
      api.createRecord('66c61334', component.options)
    } else {
      api.reload('66c61334', component.options)
    }
    module.hot.accept("./ImportContacts.vue?vue&type=template&id=66c61334&", function () {
      api.rerender('66c61334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/contacts/components/ImportContacts.vue"
export default component.exports